import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { FaEllipsisV } from 'react-icons/fa';
import TEST from '../../../img/circly-project.png';
import { isFeatureEnabled } from '../../../services/feature-flags';
import Tooltip from '../../common/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { copyBoard, deleteBoard } from '../../../services/api/api';
import ConfirmDeleteBoard from './ConfirmDeleteBoard';
import { LoadingSpinner } from '../../common/loading-spinner/LoadingSpinner';

const maxDisplayedTitleLength = 50;

const BoardTile = ({ board, reloadBoards }) => {
  const displayedTitle =
    board.title.length > maxDisplayedTitleLength
      ? board.title.slice(0, maxDisplayedTitleLength) + '...'
      : board.title;

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const isMenuOpen = Boolean(menuAnchorEl);

  const handleClick = event => {
    event.preventDefault();
    setMenuAnchorEl(event.currentTarget);
  };
  const handleClose = event => {
    event.preventDefault();
    setMenuAnchorEl(null);
  };

  const [isCopyLoading, setIsCopyLoading] = useState(false);
  const handleCopy = async event => {
    event.preventDefault();
    setIsCopyLoading(true);
    const { boardId: boardCopyId } = await copyBoard(board.id);
    setIsCopyLoading(false);
    window.location.href = `/board/${boardCopyId}`;
  };

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const openDeleteModal = useCallback(event => {
    event.preventDefault();
    handleClose(event);
    setIsDeleteModalOpen(true);
  }, []);
  const closeDeleteModal = useCallback(event => {
    event.preventDefault();
    setIsDeleteModalOpen(false);
  }, []);

  const handleDelete = async event => {
    event.preventDefault();
    closeDeleteModal(event);
    await deleteBoard(board.id);
    await reloadBoards();
  };

  const isOwner = board.role === 'owner';

  return (
    <>
      <li className="project-item">
        <Link to={`/board/${board.id}`} className="project-link">
          <div className="project-circle-wrapper" style={{ position: 'relative' }}>
            {isFeatureEnabled('ALLOW_DELETING_BOARDS') && (
              <>
                <div className="board-menu-icon" aria-label="actions menu" onClick={handleClick}>
                  <FaEllipsisV />
                </div>
                <Menu anchorEl={menuAnchorEl} open={isMenuOpen} onClose={handleClose}>
                  <MenuItem disabled={isCopyLoading} onClick={handleCopy} aria-label="Copy board">
                    Copy board {isCopyLoading ? <LoadingSpinner size="small" /> : ''}
                  </MenuItem>
                  <Tooltip
                    title={isOwner ? '' : 'You need Owner role to be able to delete this board'}
                  >
                    <div>
                      <MenuItem
                        disabled={!isOwner}
                        onClick={openDeleteModal}
                        aria-label="Delete board"
                      >
                        Delete board
                      </MenuItem>
                    </div>
                  </Tooltip>
                </Menu>
              </>
            )}
            <div
              className="project-circle"
              style={{
                backgroundImage: `url(${TEST})`,
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat'
              }}
            ></div>
          </div>
          <Tooltip title={board.title.length > maxDisplayedTitleLength ? board.title : ''}>
            <div className="project-title">{displayedTitle}</div>
          </Tooltip>
          <div>
            <div className="project-date">
              edited: {`${new Date(board.updatedAt).toLocaleDateString()}`}
            </div>
            {/*<div className="project-privacy" onClick={()=> {this.openUpgradeModal()}}>Public</div>*/}
          </div>
        </Link>
      </li>
      <ConfirmDeleteBoard
        isOpen={isDeleteModalOpen}
        onClose={closeDeleteModal}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default BoardTile;
